module.exports = __webpack_public_path__ + "static/media/directions-ic.57a9593d.svg";